import { render, staticRenderFns } from "./PaymentEpay.vue?vue&type=template&id=7ccd2818&"
import script from "./PaymentEpay.vue?vue&type=script&lang=js&"
export * from "./PaymentEpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports